<template>
    <div class="filter-section-wrapper" :class="{'hideFiltersSection' : hideFiltersSection, 'isClub':isClub}" v-if="!hideFiltersSection">
        <div class="row mx-0 options-block">
            <div class="col-auto filter-settings" v-click-outside="outsideClickFilters">
                <!-- Categories -->
                <NestedMenu v-if="hasCategories && !isClub"/>
                <!-- Sorts -->
                <div v-if="availableSorts && !hideFiltersSection && !isClub" class="col-auto results-sort" v-click-outside="outsideClickSort">
                    <span class="description title"> {{ kStrings.kSORT_BY + ':' }} </span>
                    <span @click="showSortOptions = !showSortOptions" class="selection" :class="{ 'active' : showSortOptions}">
                        <span class="description"> {{ selectedSort.name }} </span>
                        <i class="ecom-chevron-down"/>
                    </span>
                    <transition name="fade">
                        <ul v-if="showSortOptions" class="drop-options">
                            <li v-for="sort in availableSorts"
                                :key="sort.identifier"
                                :data-sort="sort.order_type"
                                :data-url="sort.url"
                                class="list-option"
                                @mousedown="filterHandler(sort.url, sort.identifier)">
                                <div class="radio-wrapper">
                                    <input type="radio" :id="sort.identifier" :value="sort.identifier" :checked="sort.identifier == checkedSort ? 'checked' : ''"/>
                                    <label :for="sort.identifier"></label>
                                </div>
                                <div class="radio-content"><p> {{ sort.name }} </p></div>
                            </li>
                        </ul>
                    </transition>
                </div>
                <!-- Filters -->
                <div class="setting filter-setting" v-if="availableFilters && availableFilters.length > 0 && !isClub">
                    <span class="description title"> {{ kStrings.kFILTERS + ':' }} </span>
                </div>
                <div v-if="isClub" class="products-qty">
                    {{ catalogTitle }}
                </div>
                <div class="filters-block d-flex" v-if="availableFilters && availableFilters.length > 0">
                    <div class="element" ref="filters" @scroll="scrollEvent" >
                        <div v-for="(filter, idx) in availableFilters" class="setting" :key="'opt-ft-'+idx" :id="'opt-ft-'+idx">
                            <div class="w-100 action" :class="{'active' : showFilterOptions == idx}">
                                <div class="setting-layer" @click="menuHandler(idx, $event)"/>
                                <span class="description">
                                    {{ filter.title }} 
                                    <!-- {{ numAppliedOptions(filter.options) }} -->
                                </span>
                                <i class="ecom-chevron-down"/>
                            </div>
                            <transition name="fade">
                                <ul v-if="filter.options.length > 0 && showFilterOptions == idx"
                                    class="drop-options check-options" :id="'ft-options-'+idx"
                                    :style="{position: 'fixed', top: `${filterPos.top}px`, left: `${filterPos.left}px`}"
                                >
                                    <li v-for="(opt, index) in filter.options" 
                                        :data-url="opt.url" 
                                        :key="'filter'+index"
                                        @click.stop.prevent="filterHandler(opt.url, filter.title + '-' + index)"
                                        class="list-option">
                                        <!-- <label v-if="filter.type == 1" :for="'filter-' + filter.type + '-' + index"> 
                                            {{ formatPriceRange(opt.MIN, opt.MAX) }} 
                                        </label>                                 -->
                                        <Rating v-if="filter.type == 2" :value="opt.stars" />
                                        <!-- <input v-if="filter.type == 1" type="checkbox" :id="'filter-' + filter.type + '-' + index" :checked="opt.selected_range"/> -->
                                        <input v-if="filter.type == 2" type="checkbox" :id="'filter-' + filter.type + '-' + index" :checked="opt.selected_review"/>
                                        <input v-else type="checkbox" :id="'filter-' + filter.type + '-' + index" :checked="opt.applied"/>
                                        <input class="custom-checkbox"/><i class="ecom-check"/>
                                        <label v-if="filter.type != 2" :for="'filter-' + filter.type + '-' + index"> {{ opt.description }} </label>
                                        
                                    </li>
                                </ul>
                            </transition>
                        </div>
                    </div> 
                    <div v-if="gradientLeft" class="gradient-less"></div>
                    <div v-if="gradientRight" class="gradient-more"></div>
                </div>
                <!-- Sorts for club -->
                <div v-if="availableSorts && !hideFiltersSection && isClub" class="col-auto results-sort" v-click-outside="outsideClickSort">
                    <span @click="showSortOptions = !showSortOptions" class="selection" :class="{ 'active' : showSortOptions}">
                        <span class="description"> {{ kStrings.kSORT_BY + ':' }} {{ selectedSort.name }} </span>
                        <i class="ecom-chevron-down"/>
                    </span>
                    <transition name="fade">
                        <ul v-if="showSortOptions" class="drop-options">
                            <li v-for="sort in availableSorts"
                                :key="sort.identifier"
                                :data-sort="sort.order_type"
                                :data-url="sort.url"
                                class="list-option"
                                @mousedown="filterHandler(sort.url, sort.identifier)">
                                <div class="radio-wrapper">
                                    <input type="radio" :id="sort.identifier" :value="sort.identifier" :checked="sort.identifier == checkedSort ? 'checked' : ''"/>
                                    <label :for="sort.identifier"></label>
                                </div>
                                <div class="radio-content"><p> {{ sort.name }} </p></div>
                            </li>
                        </ul>
                    </transition>
                </div>
                <!-- End Sorts for club -->
            </div>
        </div>
        <div v-if="!hideFiltersSection" class="selected-block" :class="{'filters-applied' : appliedFilters}">
            <span v-for="applied in appliedFilters" 
                class="applied-filter" 
                :key="applied.description"
                @click.prevent="filterHandler(applied.url, 'removeFilter')">
                    {{ applied.type == 2 ? kStrings.kGLOB_SCORE + ':' : applied.description }} 
                <Rating v-if="applied.type == 2" :value="applied.rawData.stars" />
                <i class="ecom-clear"/>
            </span>
            <div v-if="appliedFilters" class="col-auto clear-setting">
                <span class="description" @click.prevent="filterHandler(urls.clearUrl, 'clear')"> 
                    {{ kStrings.kCLEAR_ALL }} 
                    <i class="ecom-clear"/>
                </span>
            </div>
        </div>
    </div>
</template>

<script>

import apiCatalog from '@/api/catalog';

import {store} from '@/store/catalog';
import {isEmpty} from 'lodash-es';

import NestedMenu from '@/components/Catalog/Desktop/sections/Filters/NestedMenu.vue';
import Rating from '@/components/Muffin/Rating';

export default {
    store,
    name: 'FilterDashboard',
    components: {
        NestedMenu,
        Rating,
    },
    props: {
        filterData: {
            type: Object,
            default: null,
        },
        sortData: {
            type: Object,
            default: null,
        },
        isClub:{
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            showFilterOptions: null,
            showSortOptions: false,
            searchBarText: null,
            gradientLeft: false,
            gradientRight: false,
            filterPos: null
        };
    },
    computed: {
        kStrings() {
            return this.$store.getters.kStrings;
        },
        urls() {
            return this.$store.getters.urls;
        },
        searchListText() {
            return this.$store.getters.searchListText;
        },
        isTextSearch() {
            return this.$store.getters.extras.isTextSearch;
        },
        hideFiltersSection() {
            return this.$store.getters.extras.hideFiltersSection;
        },
        countDescription() {
            return this.prodCount == 1 ? this.kStrings.kPRODUCT : this.kStrings.kPRODUCTS;
        },
        appliedFilters() {
            return this.filterData && this.filterData.hasFilterApplied ? this.filterData.appliedFilters : null;
        },
        availableFilters() {
            //console.log(this.hideFiltersSection);
            if(!this.filterData && !isEmpty(this.filterData.availableFilters)) {
                return null;
            }
            
            return this.filterData.availableFilters;
        },
        availableSorts() {
            return this.sortData && !isEmpty(this.sortData) ? this.sortData.availableSorts : null;
        },
        selectedSort() {
            if (!this.sortData || (!this.availableSorts)) {
                return null;
            }

            return this.availableSorts.hasOwnProperty(this.sortData.selectedSort) ? this.availableSorts[this.sortData.selectedSort] : this.availableSorts[0];
        },
        checkedSort() {
            return this.sortData && !isEmpty(this.sortData) ? this.sortData.selectedSort : null;
        },
        pagination() {
            return !isEmpty(this.$store.getters.pagination) ? this.$store.getters.pagination : null
        },
        currentPage() {
            return this.pagination ? this.pagination.currentPage : 1
        },
        itemsSeen() {
            if (!this.pagination || this.pagination.totalPages == 1) {
                return null;
            }
            
            return this.currentPage * this.pagination.pageSize;
        },
        totalProducts() {
            return this.$store.getters.totalProducts;
        },
        hasCategories(){
            const categories = this.$store.getters.categories;
            return categories.hasOwnProperty('categoryListId') && categories.categoryListId;
        },
        catalogTitle() {
            return this.$store.getters.catalogTitle;
        },
    },
    watch: {
        searchListText(value) {
            if(!value) {
                this.searchBarText = null;
            }
        }
    },
    // created() {
    // },
    mounted() {
        document.onreadystatechange = () => { 
            if (document.readyState == "complete") { 
                this.checkFiltersFit();
            } 
        }
    },
    methods: {
        async filterHandler(url, id) { // for filters & sorts
            this.$store.dispatch('setLoading', true);
            const response = await apiCatalog.backendRequest(url, id, {}, {quicksearch: "1", no_action: "1", refresh: true});
            if(response.data.hasOwnProperty('catalogData')) {
                this.$emit('updateCatalog', response.data.catalogData);
            }
            document.body.style.overflow = '';
            this.$store.dispatch('setLoading', false);
            this.showSortOptions = false;
            this.showFilterOptions = null;
        },
        
        menuHandler(index = -1, event) {
            this.filterPos = {
                top: event.target.getBoundingClientRect().top + 46,
                left: event.target.getBoundingClientRect().left - (event.target.getBoundingClientRect().width / 2) ,
            }
            document.body.style.overflow = 'hidden';
            this.showFilterOptions = this.showFilterOptions != index ? index : null;
            if(this.showFilterOptions == null) {
                document.body.style.overflow = '';
            }
        },
        outsideClickFilters() {
            document.body.style.overflow = '';
            this.showFilterOptions = null;
        },
        outsideClickSort() {
            this.showSortOptions = false;
        },
        // formatPriceRange(min, max) { // do in backend?
        //     return App.js.formatPrice(min) + ' - ' + App.js.formatPrice(max)
        // },
        numAppliedOptions(options) {
            let stringNum = '';
            if(options && options.filter(ft => ft.applied || ft.selected_review || ft.selected_range).length) {
                stringNum = '('+ (options.filter(ft => ft.applied || ft.selected_review || ft.selected_range).length) + ')';
            }
            return stringNum;
        },
        scrollEvent(){
            let elem = this.$refs.filters;
            if(elem && (elem instanceof HTMLElement)){
                this.gradientLeft = elem.scrollLeft > 1;
                this.gradientRight = elem.scrollWidth - elem.scrollLeft > (elem.offsetWidth + 1);
            }
        },
        checkFiltersFit() {
            let elem = this.$refs.filters;
            if(elem && (elem instanceof HTMLElement) && (elem.scrollWidth > elem.offsetWidth)){
                this.gradientRight = true;
            }
        }
    },
};
</script>

<style lang="scss">
    @import "././filters.scss";
</style>